<div class="flex flex-col gap-8">
  <h1 class="text-[#222528] text-[2.3125rem] font-bold text-center leading-[1.4]">
    {{ titleKey() | translate }}
  </h1>
  <workspace-breadcrumb />
  <korviu-list [config]="productListConfig" />
</div>
